// Dictionary API functions using the Free Dictionary API
export const checkWordInDictionary = async (word: string): Promise<boolean> => {
  try {
    const response = await fetch(`https://api.dictionaryapi.dev/api/v2/entries/en/${word.toLowerCase()}`);
    return response.ok;
  } catch (error) {
    console.error('Error checking word in dictionary:', error);
    return false;
  }
};
